import { Box, Icon, IconButton, Link } from '@nimbus-ds/components';
import { CloseIcon, ChevronRightIcon } from '@nimbus-ds/icons';
import { Link as LinkRoute } from 'react-router-dom';
import { ExternalLink, useResponsive } from 'commons/components';
import { TaskData, TaskActionData, ActionType } from '../types';

interface TaskActionsProps {
  data: TaskData & TaskActionData;
  actionType: ActionType;
  onAction: (data: TaskData & TaskActionData) => void;
  onSkip?: (data: TaskData & TaskActionData) => void;
}

function TaskActions({ data, actionType, onAction, onSkip }: TaskActionsProps) {
  const { isMobile: isMobileResponsive } = useResponsive();
  if (actionType === 'promote' || actionType === 'alert') {
    return (
      <Box
        display="flex"
        alignItems={
          isMobileResponsive && actionType === 'promote'
            ? 'flex-start'
            : 'center'
        }
        gap="2"
      >
        {(!isMobileResponsive || actionType === 'alert') &&
          (data.ctaExternal ? (
            <ExternalLink
              href={data.ctaLink}
              textDecoration="none"
              appearance="primary"
              fontSize="caption"
              onClick={() => onAction(data)}
            >
              {data.ctaText}
            </ExternalLink>
          ) : (
            <Link
              data-style="task-action-link"
              textDecoration="none"
              appearance="primary"
              fontSize="caption"
              lineHeight="caption"
              as={LinkRoute}
              onClick={() => onAction(data)}
              to={data.ctaLink || '#'}
            >
              {data.ctaText || 'Acción'}
            </Link>
          ))}
        {typeof onSkip === 'function' && (
          <IconButton
            as="div"
            backgroundColor="transparent"
            size="1rem"
            source={<Icon source={<CloseIcon />} color="neutral-interactive" />}
            onClick={() => onSkip(data)}
          />
        )}
      </Box>
    );
  }

  if (actionType === 'recommendation') {
    return (
      <Box display="flex" alignItems="center">
        <IconButton
          as="div"
          backgroundColor="transparent"
          size="1rem"
          source={
            <Icon
              source={<ChevronRightIcon size="small" />}
              color="primary-interactive"
            />
          }
          onClick={() => onAction(data)}
        />
      </Box>
    );
  }

  return null;
}

export default TaskActions;
